import log from 'loglevel';

/** Writes `text` to the system clipboard via the Clipboard API. Logs then rethrows on failure. */
export async function copyStringToClipboard(text: string): Promise<void> {
  try {
    await navigator.clipboard.writeText(text);
  } catch (err) {
    log.error('Failed to copy text: ', err);
    throw err;
  }
}
